import { useMutation } from '@tanstack/react-query'
import { toast } from 'sonner'

import { createTransfer } from '../../../api/transfers/create-transfer'
import { twoButtonsConfig } from '../../../lib/utils/buttons-config/validation-buttons-config'
import { showAxiosError } from '../../../lib/utils/functions/misc.functions'
import TransferForm from '../transfers/transfer-form'

interface TripFolderCreateTransferProps {
  toggleModal: () => void
  className?: string
}

const TripFolderCreateTransfer = ({ toggleModal, className }: TripFolderCreateTransferProps) => {
  const { mutateAsync } = useMutation({
    mutationFn: createTransfer,
    onError: showAxiosError,
    onSuccess: () => {
      toast.success('Transfert créé avec succès')
      toggleModal()
    }
  })

  return (
    <div className={className}>
      <TransferForm
        className={'p-0 border-none pb-4'}
        buttonsConfig={twoButtonsConfig({
          onConfirm: async (values) => {
            await mutateAsync(values)
          },
          onCancel: toggleModal
        })}
      />
    </div>
  )
}
export default TripFolderCreateTransfer
